import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [cardNumber, setCardNumber] = useState('');
  const [loading, setLoading] = useState(true);

  // Check if user is already logged in (from localStorage)
  useEffect(() => {
    const storedCard = localStorage.getItem('memberCardNumber');
    if (storedCard) {
      setCardNumber(storedCard);
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const login = (card) => {
    // Simple validation: 16 digits (spaces allowed)
    const cleanCard = card.replace(/\s/g, '');
    
    // Valid card numbers (for now just check format)
    const validCards = ['5174252000033315']; // Test card
    
    if (cleanCard.length === 16 && /^\d+$/.test(cleanCard)) {
      // For now, accept any 16-digit number or specific test cards
      if (validCards.includes(cleanCard) || cleanCard.length === 16) {
        setCardNumber(card);
        setIsAuthenticated(true);
        localStorage.setItem('memberCardNumber', card);
        return { success: true };
      }
    }
    
    return { success: false, error: 'Numéro de carte invalide' };
  };

  const logout = () => {
    setCardNumber('');
    setIsAuthenticated(false);
    localStorage.removeItem('memberCardNumber');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, cardNumber, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
